import React from "react";
import {
  FaGamepad,
  FaImages,
  FaVrCardboard,
  FaTrophy,
  FaBuilding,
  FaLaptopCode,
} from "react-icons/fa";

const industries = [
  { name: "Gaming Studios", icon: <FaGamepad />, color: "#ff6b6b" },
  { name: "NFT Marketplaces", icon: <FaImages />, color: "#feca57" },
  { name: "Metaverse Developers", icon: <FaVrCardboard />, color: "#48dbfb" },
  { name: "eSports Companies", icon: <FaTrophy />, color: "#1dd1a1" },
  { name: "Corporate Clients", icon: <FaBuilding />, color: "#a78bfa" },
  { name: "IT Companies", icon: <FaLaptopCode />, color: "#22d3ee" },
];

function CorporatesSer() {
  return (
    <div className="corporate-dark-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h2 className="title text-white">
                Corporates & Businesses We Serve
              </h2>
              <p className="text-light mt-3">
                We empower diverse industries with scalable blockchain and
                crypto solutions.
              </p>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          {industries.map((item, index) => (
            <div className="col-lg-2 col-md-4 col-6 mb-30" key={index}>
              <div className="dark-card text-center">
                {/* ICON */}
                <div
                  className="dark-icon"
                  style={{ backgroundColor: item.color + "20" }}
                >
                  {React.cloneElement(item.icon, {
                    size: 26,
                    color: item.color,
                  })}
                </div>

                <h5>{item.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CorporatesSer;
